import React from 'react'
import once from 'lodash/once'

export const getPopupLayerElement = once(() => {
  const div = document.createElement('div')
  div.className = 'portal'
  return div
})

export default class PopupLayer extends React.Component {
  shouldComponentUpdate() {
    return false
  }

  render() {
    return (
      <div ref={(div) => div && div.appendChild(getPopupLayerElement())} className="popup-layer" />
    )
  }
}
